import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router';
import { LibxFeaturedEntryPage } from './LibxFeaturedEntryPage';
import { PageNotFound } from '../../shop/PageNotFound';
import { LibxGenresContainer } from './genres/LibxGenresContainer';
import LibxProductDetailPage from './productdetail/LibxProductDetailPage';
import { LocalRegionsPage } from './localregions/LocalRegionsPage';
import { NewlyAddedPage } from './NewlyAddedPage';
import { AllTitlesPage } from './AllTitlesPage';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';
import { LocalRegionsRedirect } from './localregions/LocalRegionsRedirect';

const LibxRouteSwitch = () => {
    const { path, url } = useRouteMatch();
    const { pathname, search } = useLocation();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    if (isMultiLanguageShopEnabled) {
        return (
            <Switch>
                <Route exact path={`${path}/products/:productId`}>
                    <LibxProductDetailPage />
                </Route>
                <Route>
                    <Redirect to={{ pathname: `/shop/en${pathname}`, search }} />
                </Route>
            </Switch>
        );
    }

    return (
        <Switch>
            <Route exact path={path}>
                <Redirect to={`${url}/featured`} />
            </Route>
            <Route exact path={`${path}/products/:productId`}>
                <LibxProductDetailPage />
            </Route>
            <Route exact path={`${path}/featured`}>
                <LibxFeaturedEntryPage />
            </Route>
            <Route exact path={`${path}/newlyadded`}>
                <NewlyAddedPage />
            </Route>
            <Route exact path={`${path}/products`}>
                <AllTitlesPage />
            </Route>
            <Route path={`${path}/genres/:genre?/:subGenre?`}>
                <LibxGenresContainer />
            </Route>
            <Route exact path={`${path}/localregions`}>
                <LocalRegionsRedirect />
            </Route>
            <Route path={`${path}/localregions/:level1/:level2?`}>
                <LocalRegionsPage />
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};

export default LibxRouteSwitch;
